export const isNumber = (str: any) => !isNaN(str) && !isNaN(parseFloat(str));
